<div class='header-line' fxLayout fxLayoutAlign='space-between center'>
  <div fxLayout fxLayoutAlign='start center' fxLayoutGap='48px'>
    <div class='table-title'>{{ dashboardTitle }}</div>
    <app-filter-bar
      *ngIf="initDates"
      [filters]="['dateRange']"
      [initialValue]="initDates"
      [smallNewDateRange]="true"
      [preventFiltersStore]="true"
      (filterChanges)="onFilterChanges($event)"
    ></app-filter-bar>
  </div>
</div>

<div class="progress-bar-wrapper" style="margin-top: 16px">
  <mat-progress-bar *ngIf="isLoading" [mode]="'indeterminate'"></mat-progress-bar>
</div>

<ng-container *ngIf="!isLoading">
  <div class="container">
    <mat-table [dataSource]="dataSource" class="mat-elevation-z1">
      <ng-container matColumnDef='isImportant'>
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef='let element'>
          <button mat-icon-button (click)='changeImportance(element)'>
            <mat-icon [class.warning]="element?.isImportant">priority_high</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="region">
        <mat-header-cell *matHeaderCellDef>{{'CRITICAL_ORDERS.REGION' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element?.region || '-' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="company">
        <mat-header-cell *matHeaderCellDef>{{'COMPANY' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element?.company || '-' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="order">
        <mat-header-cell *matHeaderCellDef>{{'CRITICAL_ORDERS.ORDER' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element?.order || '-' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="stage">
        <mat-header-cell *matHeaderCellDef>{{'STAGE' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field>
            <mat-label>{{'STAGE_LABEL' | translate}}</mat-label>
            <mat-select [formControl]="selectedStageControlsSet[element.metricId]"
                        (selectionChange)="updateCriticalStage({
                          id: element?.metricId,
                          criticalOrderStage: selectedStageControlsSet[element.metricId].value
                        })">
              <mat-option *ngFor="let item of stages" [value]="item?.id">{{ item.title }}</mat-option>
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="comment">
        <mat-header-cell *matHeaderCellDef>{{'COMMENT' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element" style="cursor: pointer" (click)="element?.commentText?.length ? openComment(element) : null">
          <span class="comment-text">{{ element?.commentText?.length ? element?.commentText[0] : '-' }}</span>
          <mat-icon *ngIf="element?.commentText.length" class="comment-icon" svgIcon="chat-reverse"></mat-icon>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
</ng-container>
